export const DEFAULT_BUSINESS_TYPE = 'SHIPPER';
export const DEFAULT_TIMEZONE = 'EASTERN_STANDARD_TIME_US_CANADA';
export const DEFAULT_CULTURE = 'US_ENGLISH';
export const DEFAULT_SHIPMENT_MODE = 'LTL';
export const DEFAULT_SHIPMENT_DIRECTION = 'OUTBOUND';
export const DEFAULT_UNIT_PACKAGE_TYPE = 'PALLET';
export const PACKAGE_TYPE_PALLET = 'PALLET';
export const DEFAULT_SHIPMENT_UNIT_COUNT = 1;
export const DEFAULT_SHIPMENT_ITEM_COUNT = 1;
export const GENERAL_NOTES_TYPE = 'GENERAL';
export const DEFAULT_BRANDING_ID = 1;
export const DEFAULT_ORGANIZATION_TYPE_ID = 'DEMO';
export const DEFAULT_COUNTRY = 'US';
export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_UNIT_TYPE = 'IMPERIAL';
export const DEFAULT_RATE_PROVIDER_ID = 'PROJECT_44';
export const DEFAULT_NETTERMS = 'NET_30';
export const DEFAULT_EMPTY = '--';
export const DEFAULT_CHECK_DIGIT_TYPE = 'NONE';
export const CHECK_DIGIT_TYPE_NONE = 'NONE';
export const CUBIC_INCHES_PER_CUBIC_FOOT = 1728;
export const CUBIC_CENTIMETERS_PER_CUBIC_METER = 1000000;
export const IMPERIAL_VOLUME = 'CUBIC_FEET';
export const METRIC_VOLUME = 'CUBIC_METERS';
export const STATUS_UPDATE_TIMEOUT = 60; //seconds between updates to file inbox/notifications

export const MAX_ITEMS_PER_REQUEST = 50;
export const MAX_COMMENT_CHAR = 175;
export const MINUTES_IN_A_HOUR = 60;

export const COUNTRY_US = 'US';

export const UNIT_ABBREVIATIONS = {
  INCHES: 'in',
  CENTIMETERS: 'cm',
  POUNDS: 'lbs',
  KILOGRAMS: 'kg',
  CUBIC_FEET: 'ft',
  CUBIC_METERS: 'm',
  POUNDS_PER_CUBIC_FOOT: 'lbs/ft',
  KILOGRAMS_PER_CUBIC_METER: 'kg/m'
};
export const CURRENCY_SYMBOL = {
  USD: '$'
};
export const ObjectTypes = [
  'INVALID',
  'USER',
  'ORGANIZATION',
  'BUSINESS',
  'DIVISION',
  'LOCATION',
  'ORGUSER',
  'PERMISSIONPROFILE'
];
export const AUTOCOMPLETE_MAX_RESULTS = 10;

export const MAX_CHARACTERS_DISPLAYED = 160;

export const GLOBAL_PROPS_KEY = 'PropelGlobal';
export const PROPEL_URL_KEY = 'PropelURL';

export const IS_PROPEL_ADMINISTRATOR_KEY = 'isPropelAdministrator';
export const PERMISSIONS_KEY = 'permissions';

export const initialOrg = {
  name: '',
  externalId: '',
  businessType: DEFAULT_BUSINESS_TYPE,
  timeZoneId: DEFAULT_TIMEZONE,
  superUserLoginEmail: '',
  superUserFirstName: '',
  superUserMiddleName: '',
  superUserLastName: ''
};

export const initialUser = {
  timeZoneId: DEFAULT_TIMEZONE,
  cultureId: DEFAULT_CULTURE,
  loginEmail: '',
  verifyLoginEmail: '',
  recoveryEmail: '',
  verifyRecoveryEmail: ''
};

export const initialBusiness = {
  name: '',
  externalId: '',
  businessType: DEFAULT_BUSINESS_TYPE,
  orgId: 0,
  id: 0,
  rowVersion: ''
};

export const TAB_CREATE_ORG = 0;
export const TAB_EDIT_ORG = 1;
export const TAB_CREATE_USER = 2;
export const TAB_EDIT_USER = 3;
export const TAB_SHIPMENT_LIST = 4;

export const MODE_CREATE = 0;
export const MODE_EDIT = 1;

//max lens
export const LEN_TINY = 10;
export const LEN_SHORT = 20;
export const LEN_MEDIUM = 40;
export const LEN_LONG = 100;
export const LEN_TEXT = 500;
export const LEN_EXTERNAL_ID = LEN_MEDIUM;

export const CHARGE_CATEGORY_IDS = {
  accessorial: 'ACCESSORIAL',
  transit: 'TRANSIT',
  fuel: 'FUEL'
};
//Timespan constants
export const MONTH = 'month';
export const DAY = 'day';
export const WEEK = 'week';
export const YEAR = 'year';

export const DATE_RANGE_TYPE_DAY_OF_WEEK = 'DAY_OF_WEEK';
export const DATE_RANGE_TYPE_WEEK = 'WEEK';
export const DATE_RANGE_TYPE_MONTH = 'MONTH';
export const DATE_RANGE_TYPE_YEAR = 'YEAR';

export const DATATYPES = {
  NUMBER: 'NUMBER',
  STRING: 'STRING'
};

export const DEFAULT_ROWS_PER_PAGE = 10;
export const DEFAULT_DEBOUNCE_DELAY = 500;
export const FORMACTIONS = {
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  TENDER: 'TENDER',
  MANUALLY_TENDER: 'MANUALLY_TENDER',
  RATE: 'RATE',
  DRAFT: 'DRAFT'
};
export const SHIPMENT_DIRECTION = {
  OUTBOUND: 'OUTBOUND',
  INBOUND: 'INBOUND',
  DROP: 'DROP',
  SHUTTLE: 'SHUTTLE'
};
export const SHIPMENT_TYPE = {
  LTL: 'LTL',
  PARCEL: 'PARCEL',
  TRUCK_LOAD: 'TRUCK_LOAD'
};
export const SHIPMENT_STATUS = {
  AUTO_TENDERING: 'AUTO_TENDERING',
  INVALID: 'INVALID',
  SAVED: 'SAVED',
  READY_TO_TENDER: 'READY_TO_TENDER',
  OPTIMIZING: 'OPTIMIZING',
  TENDER_REQUESTED: 'TENDER_REQUESTED',
  TENDER_REJECTED: 'TENDER_REJECTED',
  AUTO_TENDER_TRANSIENT_FAILURE: 'AUTO_TENDER_TRANSIENT_FAILURE',
  AUTO_TENDER_PERMANENT_FAILURE: 'AUTO_TENDER_PERMANENT_FAILURE',
  WAITING_FOR_PICKUP: 'WAITING_FOR_PICKUP',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERED: 'DELIVERED',
  CANCELLED: 'CANCELLED',
  ABANDONED: 'ABANDONED',
  EXCEPTION: 'EXCEPTION'
};

export const SHIPMENT_IN_TRANSIT_STATUS = {
  INVALID: 'INVALID',
  EARLY: 'EARLY',
  ON_TIME: 'ON_TIME',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  DELAYED: 'DELAYED'
};

export const allowedFileTypes = {
  'image/jpeg': 'JPG',
  'image/jpg': 'JPG',
  'image/png': 'PNG',
  'application/pdf': 'PDF'
};
export const PHONE_COUNTRY_CODES = {
  US: '1',
  CA: '1',
  MX: '52'
};
export const COUNTRY_PHONE_MASK = {
  US: '(###) ###-####',
  CA: '(###) ###-####',
  MX: '##########'
};

export const USER_ROLE = {
  SHIPPER: 'SHIPPER',
  ADMIN: 'ADMIN',
  QUOTER: 'QUOTER'
};

export const FREIGHT_CLASSES = {
  CLASS_50: 'CLASS_50',
  CLASS_55: 'CLASS_55',
  CLASS_60: 'CLASS_60',
  CLASS_65: 'CLASS_65',
  CLASS_70: 'CLASS_70',
  CLASS_77_5: 'CLASS_77_5',
  CLASS_85: 'CLASS_85',
  CLASS_92_5: 'CLASS_92_5',
  CLASS_100: 'CLASS_100',
  CLASS_110: 'CLASS_110',
  CLASS_125: 'CLASS_125',
  CLASS_150: 'CLASS_150',
  CLASS_175: 'CLASS_175',
  CLASS_200: 'CLASS_200',
  CLASS_250: 'CLASS_250',
  CLASS_300: 'CLASS_300',
  CLASS_400: 'CLASS_400',
  CLASS_500: 'CLASS_500'
};

const helpScoutMessagingMode = {
  selfService: 'selfService',
  neutral: 'neutral',
  askFirst: 'askFirst'
};

export const HELPSCOUT_ACCOUNT = {
  Default: {
    brandingID: '1',
    subscriptionID: 'bad9a49e-3c7e-4f0d-a4ad-6b00edc55927',
    messagingEnabled: true,
    chatEnabled: true,
    messagingMode: helpScoutMessagingMode.askFirst
  },
  Ward: {
    brandingID: '2',
    subscriptionID: '32c56eef-339c-43b0-9151-1ce32f416dd7',
    messagingEnabled: true,
    chatEnabled: true,
    messagingMode: helpScoutMessagingMode.askFirst
  }
};

export const BILL_TO = {
  SHIPPER: 'SHIPPER',
  CONSIGNEE: 'CONSIGNEE',
  THIRD_PARTY: 'THIRD_PARTY'
};
export const LOCATION_TYPE = {
  PICKUP: 0,
  DELIVERY: 1
};

export const BOL_DISCLAIMER = `Note Liability: Limitation for loss or damage in this shipment may be applicable.
  See 49 U.S.C. AY 14706(c)(I)(A)and(B). RECEIVED, subject to the rates, classiﬁcations and rules that have
  been established by the Carrier and are available on request to the Shipper
  (Shipper deﬁned in 49 U.S.C.A. § 13102(13)(c)), and to all applicable state and federal regulations.
  Shipper 1)warrants it has read all applicable contract(s) or Carrier’s applicable tariﬀ(s) and the
  limitation of liability provisions set forth therein; and 2) has actual knowledge of and accepts the
  applicable contract or tariﬀ terms, including the limits on carrier liability Carriers’ tariﬀ(s),
  including OD Rules 100, take precedence in the event of any terms or conditions conﬂicts. `;

export const BOL_SHIPPER_TEXT = `The carrier shall not make delivery of this shipment without payment of freight
  and all other lawful charges. This is to certify that the above named materials are properly classiﬁed, described,
  packaged, marked and labeled, and are in proper condition for transportation according to the applicable regulations
  of the U.S. DOT.`;

export const BOL_CARRIER_TEXT = `Carrier acknowledges receipt of packages and required placards. Carrier certiﬁes
  emergency response information was made available and/or carrier has the U.S. DOT emergency response guidebook or
  equivalent documentation in the vehicle.`;
export const CUSTOM_FIELD_VISIBILITY_VALUE = 'SHOW';
export const CUSTOM_FIELD_HIDDEN_VALUE = 'SELECT';

export const DEFAULT_BILLING_TERMS = {
  BASED_ON_DIRECTION: 'SET_BASED_ON_DIRECTION',
  THIRD_PARTY: 'THIRD_PARTY'
};

export const DASHBOARD_MAX_CARRIERS = 4;

export const INVOICE_STATUS = {
  IN_REVIEW: 'IN_REVIEW',
  AWAITING_REVISION: 'AWAITING_REVISION',
  DISPUTED: 'DISPUTED',
  PARSING_ERROR: 'PARSING_ERROR'
};

export const PACKAGE_TYPE_NOT_APPLICABLE = 'NOT_APPLICABLE';
export const PACKAGE_TYPE_PIECE = 'PIECE';

export const ERROR_SEVERITY_TEXT = {
  ERROR: 'Error',
  WARNING: 'Warn',
  INFO: 'Info',
  NONE: 'None'
};

export const ERROR_SEVERITY = {
  Error: 3,
  Warn: 2,
  Info: 1,
  None: 0
};

export const SEARCH_RESULT_TYPES = {
  SHIPMENT: 'SHIPMENT',
  SHIPMENT_INVOICE: 'SHIPMENT_INVOICE',
  SHIPMENT_FILE: 'SHIPMENT_FILE',
  SHIPMENT_EXCEPTION_REASON: 'SHIPMENT_EXCEPTION_REASON',
  SHIPMENT_RATE: 'SHIPMENT_RATE',
  INVOICE: 'INVOICE',
  INVOICE_SYNOPSIS: 'INVOICE_SYNOPSIS',
  INVALID: 'INVALID',
  DIVISION: 'DIVISION',
  CARRIER: 'CARRIER',
  REMITTANCE_BATCH: 'REMITTANCE_BATCH',
  CARRIER_BUSINESS: 'CARRIER_BUSINESS',
  BUSINESS: 'BUSINESS',
  CONTACT: 'CONTACT',
  ORG_USER: 'ORG_USER',
  USER: 'USER',
  INVOICE_SYNOPSIS: 'INVOICE_SYNOPSIS',
  PRODUCT_CATEGORY: 'PRODUCT_CATEGORY',
  PRODUCT: 'PRODUCT_CATEGORY',
  ORG_ACCESSORIAL_SERVICE: 'ORG_ACCESSORIAL_SERVICE',
  ORGANIZATION_EMAIL_ALIAS: 'ORGANIZATION_EMAIL_ALIAS',
  FILE_UPLOAD: 'FILE_UPLOAD',
  PERMISSION_PROFILE:'PERMISSION_PROFILE',
  TRACKING_NOTIFICATION: 'TRACKING_NOTIFICATION',
  BUSINESS: 'BUSINESS',
  GL_CODE: 'GL_CODE',
  LOCATION: 'LOCATION',
  BRANDING: 'BRANDING',
  HAZ_MAT: 'HAZ_MAT',
  LCP_EXCEPTION_REASON: 'LCP_EXCEPTION_REASON',
  CUSTOM_FIELD: 'CUSTOM_FIELD'



};

export const FIELDS_REQUIRED_TO_RATE = [
  'shipmentDirectionId',
  'shipmentModeId',
  'handlingUnits',
  'pickup.plannedToTimeLocal',
  'pickup.locationAddress.postalCode',
  'pickup.locationAddress.country',
  'delivery.locationAddress.postalCode',
  'delivery.locationAddress.country',
  'totalLinearFeet',
  'requestedServices'
];
